// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"SocialButton_socialButton__JEtKw","icon":"SocialButton_icon__K_X1K","label":"SocialButton_label__IeqT9"};